<template>
  <div class="">
    <form @submit.prevent="getDeliveryChallan()">
      <card-component>
        <div class="columns">
          <div class="column is-4">
            <div class="field">
              <div class="">
                <input class="input" required type="text" name="poid" placeholder="Poid" v-model="poid" />
              </div>
            </div>
          </div>
          <div class="column is-3">
            <button class="button is-success" type="submit">Get Delivery Challan</button>
          </div>
        </div>
      </card-component>
    </form>
    <div class="">
      <iframe id="iframeReceipt" name="iframeReceipt" style="height:0;width:0;"></iframe>
      <section ref="invoice" style="display:none" id="printableArea">
        <div>
          <center><br />Delivery Challan</center>
        </div>
        <table width="100%" cellspacing="0">
          <tr>
            <td align="left" width="50%">
              <span class="deliveryChallan"> Bill To / Ship To,</span><br />
              <span class="deliveryChallan" v-if="deliveryData.parentDetail"> Name : {{ deliveryData.parentDetail.name }} </span><br />
              <span class="deliveryChallan" v-if="deliveryData.parentDetail">
                Address : {{ deliveryData.parentDetail.address }},<br />
                {{ deliveryData.parentDetail.city + ' ' + deliveryData.parentDetail.pincode }}</span
              ><br /><br />

              <span class="deliveryChallan"> Delivery Challan No : {{ deliveryData.deliveryChallanNo }} </span><br />
              <span class="deliveryChallan"> Delivery Challan Date : {{ deliveryData.deliveryChallanDate }} </span><br />
              <span class="deliveryChallan"> Place Of Supply : {{ deliveryData.placeOfSupply }} </span> <br />
              <span class="deliveryChallan"> Reference to Invoice No. : {{ deliveryData.invoiceNo }} </span> <br />
              <span class="deliveryChallan"> System Reference No. : {{ deliveryData.poID }} </span> <br />
            </td>
            <td align="right" width="50%">
              <br />
              <span class="deliveryChallan" v-if="deliveryData.franchisee"> Consigner Name : {{ 'Firstcry Intellitots Pre-School,' + deliveryData.franchisee.companyName }} </span><br />
              <span class="deliveryChallan" v-if="deliveryData.franchisee"> Trust Name : {{ deliveryData.franchisee.trustName || '-' }} </span><br />
              <span class="deliveryChallan" v-if="deliveryData.franchisee">
                Address : {{ deliveryData.franchisee.address1 }}<br />
                {{ deliveryData.franchisee.city + ' ' + deliveryData.franchisee.state + ' ' + deliveryData.franchisee.pincode }} </span
              ><br />
              <span class="deliveryChallan" v-if="deliveryData.franchisee">GSTN : {{ deliveryData.franchisee.gstNo }} </span><br /><br />
              <br /><br /><br />
              <span class="deliveryChallan"> Dispatch From </span><br />
              <span class="deliveryChallan" v-if="deliveryData.wareHouse">
                Address : {{ deliveryData.wareHouse.WareHouseAddress }},<br />
                {{ deliveryData.wareHouse.WareHouseCity + ' ' + deliveryData.wareHouse.PinCode }}</span
              >
            </td>
          </tr>
        </table>

        <br />
        <table class="invoiceTable" width="100%">
          <thead>
            <tr>
              <td class="has-text-left has-text-weight-bold">Sr. No</td>
              <td class="has-text-left has-text-weight-bold">Item Description</td>
              <td class="has-text-left has-text-weight-bold">HSN Code</td>
              <td class="has-text-left has-text-weight-bold">Taxable Amount</td>
              <td class="has-text-left has-text-weight-bold">Tax Rate</td>
              <td class="has-text-left has-text-weight-bold" v-if="isIGST">IGST</td>
              <td class="has-text-left has-text-weight-bold" v-if="!isIGST">CGST</td>
              <td class="has-text-left has-text-weight-bold" v-if="!isIGST">SGST</td>
              <td class="has-text-left has-text-weight-bold">Total Amount</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(order, index) in deliveryData.orderDetails" :key="index">
              <td class="has-text-right">{{ index + 1 }}</td>
              <td class="has-text-right">{{ order.itemInstructions }}</td>
              <td class="has-text-right">{{ order.hsnCode }}</td>
              <td class="has-text-right">{{ order.taxableAmount }}</td>
              <td class="has-text-right">{{ order.taxRate }} %</td>
              <td class="has-text-right" v-if="isIGST">{{ order.IGST }}</td>
              <td class="has-text-right" v-if="!isIGST">{{ order.CGST }}</td>
              <td class="has-text-right" v-if="!isIGST">{{ order.SGST }}</td>
              <td class="has-text-right">{{ order.totalAmount }}</td>
            </tr>
            <tr>
              <td class="has-text-right"></td>
              <td class="has-text-right">Total Amount:</td>
              <td class="has-text-right"></td>
              <td class="has-text-right"></td>
              <td class="has-text-right"></td>
              <td class="has-text-right" v-if="isIGST"></td>
              <td class="has-text-right" v-if="!isIGST"></td>
              <td class="has-text-right" v-if="!isIGST"></td>
              <td class="has-text-right">{{ totalAmounts }}</td>
            </tr>
          </tbody>
        </table>
        <br />
        <b>Note: Materials contained in this kit are part of the educational curriculum of FirstCry Intellitots Preschool and are not for retail sale.</b>
        <br /><br />
        <table width="100%" cellspacing="0">
          <tr>
            <td align="left" width="50%"></td>
            <td align="right" width="50%">
              <span class="deliveryChallan" v-if="deliveryData.franchisee"> M/S : {{ 'Firstcry Intellitots Pre-School,' + deliveryData.franchisee.companyName }} </span><br />
            </td>
          </tr>
        </table>

        <br />
        <table width="100%" cellspacing="0">
          <tr>
            <td align="left" width="65%">
              This is a Computer generated Delivery Challan and required no signature & stamp.
            </td>
          </tr>
        </table>
      </section>
    </div>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import CardComponent from '@/components/template/CardComponent'
import Utils from '@/utils'

export default {
  name: 'DeliveryChallan',
  components: {
    CardComponent
  },
  data () {
    return {
      poid: '',
      deliveryData: {},
      isIGST: false,
      totalAmounts: 0,
      loadingComponent: null
    }
  },
  methods: {
    getDeliveryChallan: async function () {
      if (!this.poid) return
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/order/chalan/${this.poid}`)
        if (data) {
          this.deliveryData = data

          if (this.deliveryData && this.deliveryData.franchisee && this.deliveryData.wareHouse) {
            if (this.deliveryData.franchisee.state.toLowerCase() !== this.deliveryData.wareHouse.WareHouseState.toLowerCase()) {
              this.isIGST = true
            }
            this.totalAmounts = Utils.sumBy(this.deliveryData.orderDetails, obj => Number(obj.totalAmount))
          }
          this.loadingComponent.close()
          this.$nextTick(() => {
            this.print()
          })
        }
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    print: async function () {
      const printContents = document.getElementById('printableArea').innerHTML
      const documentHead =
        `<!DOCTYPE html><html lang="en"><head><style>
      @page{margin-top:0px;margin-bottom:0px;}
      body{margin:0;padding:0;font-family:Consolas,arial;font-size:11px;}
      .invoiceTable{border:1px solid;box-sizing: border-box;border-collapse: collapse;}
      .invoiceTable td{border-right:1px solid;border-bottom:1px solid;box-sizing: border-box;vertical-align:top;}
      .invoiceTable td.noBorder{border:none;}
      .deliveryChallan{line-height: 1.5}
      </style></head><body>` +
        printContents +
        `</body></html>`
      const doc = document.getElementById('iframeReceipt').contentWindow.document
      doc.open()
      doc.write(documentHead)
      window.frames['iframeReceipt'].focus()
      window.frames['iframeReceipt'].print()
      doc.removeChild(doc.documentElement)
    }
  }
}
</script>
